// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_5a56f6b7","outerContainer":"e53f90c2","secondaryToolbar":"ba47ed22","doorHangerRight":"_70a4780f","toolbarContainer":"ffd83e41","toolbarViewerMiddle":"_9325fd6d","progressBar":"_60172739","back-to-application":"_5a8bca7c","image":"_848967a9","image--bordered":"_06f775ac"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/group.styl
// module id = 4920
// module chunks = 39